<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :backFalg="true"
      @back="back"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      @pageChange="handleSearch"
    >
      <template slot="createTime" slot-scope="scope">
        <span>{{parseTime(scope.data.createTime, '{y}-{m}-{d}') }}</span>
      </template>
      <template slot="price" slot-scope="scope">
        <span>{{ThousandAndDecimal(scope.data.price) }}</span>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleSee(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          @click="handleDel(scope.data, scope.$index)"
          type="text"
          size="small"
          class="delbutton"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :supplierId="queryParams.supplierId" :is="currentView"></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/library/logistics/components/carForm'
import { getvehicleDetailList, saveVehicleDetail, deleteLogic } from '@/api/library/logistics'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    return {
      type: '',
      queryParams: { supplierId: '', pageNo: 1, pageSize: 10 },
      authIdentity: 'library:carDetail',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'licensePlate',
          label: '车牌号',
          isTrue: true,
        },
        {
          prop: 'price',
          formSolt: true,
          label: '运输单价(元)',
          isTrue: true,
        },
        {
          prop: 'createTime',
          label: '创建时间',
          isTrue: true,
          formSolt: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'licensePlate',
          placeholder: '请输入车牌号',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.queryParams.supplierId = this.$route.query.id
    this.getvehicleDetailList()
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteLogic({ id: row.id }).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功！`)
              this.getvehicleDetailList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleUpdata(row) {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '修改车辆'
        this.type = 'edit'
        this.$refs.myform.getDetail(row, this.type)
      })
    },
    handleSee(row) {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '查看车辆'
        this.type = 'preview'
        this.$refs.myform.getDetail(row, this.type)
      })
    },
    getvehicleDetailList() {
      getvehicleDetailList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    back() {
      this.$router.push({ path: '/logistics' })
    },
    submitFrom() {
      console.log('进来')
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data)

        if (data) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getvehicleDetailList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增车辆'
        this.type = 'add'
        this.$refs.myform.add(this.type)
      })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getvehicleDetailList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        supplierId: this.$route.query.id,
      }

      this.getvehicleDetailList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
/deep/ .delbutton.el-button--text {
  color: red;
}
// @import '../../../../assets/form.less';
</style>